// extracted by mini-css-extract-plugin
module.exports = {"container":"Vh_container__3EnaU","aligner":"Vh_aligner__1vq5f","aligner_inner":"Vh_aligner_inner__MGUUU"};